import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";
import {
    b2cClientDataDownloadApi,
    productVisitorDataDownloadApi,
    leadDataDownloadApi,
    b2bClientDataDownloadApi,
    categorySalesDownloadApi,
    salesSheetExportApi
} from "../constants/apis";

// Helper function to trigger file download
export const triggerFileDownload = (response, filename) => {
    // Create blob from response data
    const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    });
    
    // Create download URL
    const url = window.URL.createObjectURL(blob);
    
    // Create temporary link element
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    
    // Trigger download
    document.body.appendChild(link);
    link.click();
    
    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

// Download B2C Client Data
export const downloadB2CClientData = async (params) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
        responseType: 'blob', // Important for file downloads
    };

    try {
        const response = await axios.post(b2cClientDataDownloadApi, params, config);
        
        // Trigger download
        triggerFileDownload(response, `b2c-client-data.xlsx`);
        return response;
    } catch (error) {
        console.error("Error downloading B2C client data:", error);
        throw error;
    }
};

// Download B2C Client Data
export const downloadB2BClientData = async (params) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
        responseType: 'blob', // Important for file downloads
    };

    try {
        const response = await axios.post(b2bClientDataDownloadApi, params, config);
        
        // Trigger download
        triggerFileDownload(response, `b2b-client-data.xlsx`);
        return response;
    } catch (error) {
        console.error("Error downloading B2B client data:", error);
        throw error;
    }
};

// Download Product Visitor Data
export const downloadProductVisitorData = async (params) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
        responseType: 'blob', // Important for file downloads
    };

    try {
        const response = await axios.post(productVisitorDataDownloadApi, params, config);
        
        // Trigger download
        triggerFileDownload(response, `product-visitor-data-${new Date().toISOString().split('T')[0]}.xlsx`);
        return response;
    } catch (error) {
        console.error("Error downloading product visitor data:", error);
        throw error;
    }
};

// Download Lead Data
export const downloadLeadData = async (params) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
        responseType: 'blob', // Important for file downloads
    };

    try {
        const response = await axios.post(leadDataDownloadApi, params, config);
        
        // Trigger download
        triggerFileDownload(response, `lead-data-${new Date().toISOString().split('T')[0]}.xlsx`);
        return response;
    } catch (error) {
        console.error("Error downloading lead data:", error);
        throw error;
    }
};

// Download Category Sales Report
export const downloadCategorySalesReport = async (params) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
        responseType: 'blob', // Important for file downloads
    };

    try {
        const response = await axios.post(categorySalesDownloadApi, params, config);
        
        // Trigger download
        triggerFileDownload(response, `category-sales-report-${new Date().toISOString().split('T')[0]}.xlsx`);
        return response;
    } catch (error) {
        console.error("Error downloading category sales report:", error);
        throw error;
    }
};


// Sales sheet: one .xlsx, or a .zip of one .xlsx per order type when split.
// params: start_date, end_date, order_type, include_status (comma lists), split_files
export const downloadSalesSheet = async (params) => {
    const response = await axios.get(salesSheetExportApi, {
        headers: { "Authorization": `Token ${getUserToken()}` },
        params,
        responseType: "blob",
    });
    const type = response.headers["content-type"] || "";
    const ext = type.includes("zip") ? "zip" : "xlsx";
    const suffix = params.order_type.includes(",") ? "" : `_${params.order_type}`;
    const name = `sales_${params.start_date}_${params.end_date}${ext === "zip" ? "_reports" : suffix}.${ext}`;
    const url = window.URL.createObjectURL(new Blob([response.data], { type }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
